/**
 * source: https://tiny.amazon.com/ow812lvg/codeamazpackHVHAblobmainsrc
 */
export enum ApplicationState {
  APPT_1_PENDING = "APPT_1_PENDING",
  APPT_1_SCHEDULING = "APPT_1_SCHEDULING",
  APPT_2_PENDING = "APPT_2_PENDING",
  APPT_3_PENDING = "APPT_3_PENDING",
  ASSESSMENT_PENDING = "ASSESSMENT_PENDING",
  BGC_CONSENT_AND_INFO_PENDING = "BGC_CONSENT_AND_INFO_PENDING",
  CONDITIONAL_INTENT_PENDING = "CONDITIONAL_INTENT_PENDING",
  CONTINGENCIES_PENDING = "CONTINGENCIES_PENDING",
  DIVERSITY_PENDING = "DIVERSITY_PENDING",
  EVALUATION_PENDING = "EVALUATION_PENDING",
  HIRE_COMPLETE = "HIRE_COMPLETE",
  LOCAL_BGC_CONSENT_PENDING = "LOCAL_BGC_CONSENT_PENDING",
  NEW_HIRE_MATERIALS_PENDING = "NEW_HIRE_MATERIALS_PENDING",
  PENDING_APPT_1_SCHEDULING = "PENDING_APPT_1_SCHEDULING",
  PERSONAL_DETAILS_PENDING = "PERSONAL_DETAILS_PENDING",
  POOLING = "POOLING",
  QUESTIONS_PENDING = "QUESTIONS_PENDING",
  READY_TO_HIRE = "READY_TO_HIRE",
  REJECTED_BY_AMAZON = "REJECTED_BY_AMAZON",
  REJECTION_REVIEW_PENDING = "REJECTION_REVIEW_PENDING",
  REVIEW_AND_SUBMIT_PENDING = "REVIEW_AND_SUBMIT_PENDING",
  SCHEDULE_SELECTION_PENDING = "SCHEDULE_SELECTION_PENDING",
  SHIFT_SELECTION_PENDING = "SHIFT_SELECTION_PENDING",
  START_DATE_CONFIRMATION_PENDING = "START_DATE_CONFIRMATION_PENDING",
  WITHDRAWN = "WITHDRAWN",
}

export const SkipAppointmentOneEligibilityList = [
  "ATTEND_BY_ELIGIBILITY_CHECK",
  "ATTEND_BY_USER_SELECTION",
  "SKIP_BY_ELIGIBILITY_CHECK",
  "SKIP_BY_USER_SELECTION",
] as const;

export type SkipAppointmentOneEligibility = (typeof SkipAppointmentOneEligibilityList)[number];

export type ApplicationManageDataResponse = {
  enableCSS: boolean;
  hideWithdrawApplication: boolean;
  applicationState: ApplicationState | null;
  scheduleId?: string;
  applicationStepSubStep?: string;
  isAlumniApplication?: boolean;
  skipAppointmentOne?: SkipAppointmentOneEligibility;
};
